/* eslint-disable prefer-const */
import React from 'react';
import Translator from '../../../requests/apa/Translator';
import OptionButtonEvent from './OptionButtonEvent';
import PropTypes from 'prop-types';
import CheckBlockedChannels from '../../../requests/tasks/user/CheckBlockedChannelsTask';
import AddBlockedChannels from '../../../requests/tasks/user/AddBlockedChannelsTask';
import DeleteBlockedChannels from '../../../requests/tasks/user/DeleteBlockedChannelsTask';
import RequestManager from '../../../requests/RequestManager';
import AAFPlayer from '../../../AAFPlayer/AAFPlayer';
import AAF from '../../../AAF/AAF';
import { updateBlockedChannelsList } from '../../../AAF/Pin/PinUtil';
import { MODAL_OPTIONS_EVENT, MODAL_PIN } from '../../../actions/modal';
import { playFullMedia } from "../../../actions/playmedia";
import Utils from '../../../utils/Utils';
import { UpdateMiniObserver } from '../../PersistentMiniEpg/MiniObserver';
import Asset from '../../../requests/apa/Asset';
import { withRouter } from 'react-router';
import PinStatusWithTimerValidationTask from '../../../requests/tasks/user/PinStatusWithTimerValidationTask';
import { MODAL_PIN_CODE_LOCK_CHANNEL_TYPE_LIVE_TV } from '../../Modal/ModalPinCode';
import store from '../../../store';
import Device from '../../../devices/device';
import TvChannelUtil from '../../../utils/TvChannelUtil';
import logger from 'src/utils/logger/logger';

class BlockedChannel extends React.Component {
    constructor(props = {}) {
        super(props);
        this.state = {
            isBlocked: false,
        };
        this.isPinChannelActive = false;
        this.handleClick = this.handleClick.bind(this);
        this.handleSuccessPin = this.handleSuccessPin.bind(this);
        this.handleFailedPin = this.handleFailedPin.bind(this);
        this.imageButton_block = Asset.get(
            'playingLive_channel_option_button_lockChannel',
            '/images/ic_block.png'
        );
    }

    getGroupId() {
        const device = Device.getDevice();
        const selectData = device.getPlatform() === "tizen" ? this.props.channelData : this.props.data;
        const { group_id = '' } = selectData || {};
        return group_id;
    }

    getTitle() {
        const { isBlocked } = this.state;
        let title;
        if (isBlocked) {
            //TODO check metadata keys
            title = Translator.get(
                'panelOptions_sidemenu_item_channel_button_unlockChannel',
                'Desbloquear canal'
            );
        } else {
            title = Translator.get(
                'panelOptions_sidemenu_item_channel_button_lockChannel',
                'Bloquear canal'
            );
        }
        return title;
    }

    resetBlockedChannelState() {
        this.setState({
            isBlocked: false,
        });
    }

    getReplaceNotificationTitleString() {
        const { channelData: { title = '', channel_number = '' } = {} } = this.props;
        return `${title} ${channel_number}`;
    }

    handleModalPin(resp, type) {
        const { isBlocked } = this.state;
        let validate;

        if (type === 'SUCCESS') {
            validate = resp && resp.response && resp.response.pin_channel.status;
        } else {
            validate = resp && resp.pin_channel.status;
        }

        if (validate) {
            isBlocked ? this.launchModalPin() : this.handleSuccessPin();
        } else {
            const { history, handleClose = () => {}, stopPlayer = () => {} } = this.props;
            stopPlayer();
            handleClose();
            history.push('/user-settings/parental_control');
            //TODO redirect to QR active pin page when necessary
        }
    }

    handleClick() {
        const request = new PinStatusWithTimerValidationTask();
        RequestManager.addRequest(request)
            .then((resp) => {
                let blockedChannels = [];
                AAF.Pin.handleDataPinCodesSuccess(resp, blockedChannels);
                this.handleModalPin(resp, 'SUCCESS');
            })
            .catch((err) => {
                let blockedChannels = [];
                AAF.Pin.handleDataPinCodesError(blockedChannels);
                const resp = store.getState().pinCodes;
                this.handleModalPin(resp, 'ERROR');
                logger.error(err);
            });
    }

    launchModalPin() {
        const { showModal } = this.props;
        const { isBlocked } = this.state;
        showModal({
            modalType: MODAL_PIN,
            modalProps: {
                type: MODAL_PIN_CODE_LOCK_CHANNEL_TYPE_LIVE_TV,
                isBlocked,
                successCallBack: this.handleSuccessPin,
                failedCallBack: this.handleFailedPin,
            },
        });
    }

    async handleFlowAddDeleteBlockedChannel() {
      const {
        handleClose = () => {},
        showBlockedChannelNotification = () => {},
        showUnBlockedChannelNotification = () => {},
      } = this.props;

      try {
        const res = await this.handleRequest();
        if (res === 'add') {
            showBlockedChannelNotification(this.getReplaceNotificationTitleString());
            this.updateBlockedChannels(true);
        } else if (res === 'delete'){
            typeof showUnBlockedChannelNotification === 'function' &&
                showUnBlockedChannelNotification(this.getReplaceNotificationTitleString());
            this.updateBlockedChannels(false);
        }
        handleClose();
      } catch (err) {
          logger.error('ReminderEvent handleClick catch err', err);
      }
    }

    async handleSuccessPin(currentPin, pinIsCreated) {

        const playerOptions = AAFPlayer.getCurrentPlayerOptions();
        const isTPA = Utils.isNotNullOrNotUndefined(playerOptions.isTPA);
        const device = Device.getDevice();

        if(device.getPlatform() === "tizen") {
          this.handleFlowAddDeleteBlockedChannel();
          !isTPA && AAFPlayer.resume();
        }
        else {
          !isTPA && AAFPlayer.play()
          this.handleFlowAddDeleteBlockedChannel();
        };
    }

    handleFailedPin() {
        const playerOptions = AAFPlayer.getCurrentPlayerOptions();
        const isTPA = Utils.isNotNullOrNotUndefined(playerOptions.isTPA);
        !isTPA && AAFPlayer.play();
    }

    async handleRequest() {
        const { sendMetric = () => {} } = this.props;
        const { isBlocked } = this.state;
        const groupId = this.getGroupId();
        let request;
        const typeService = isBlocked ? 'delete' : 'add';
        if (isBlocked) {
            request = new DeleteBlockedChannels(groupId);
        } else {
            request = new AddBlockedChannels(groupId);
        }
        // sendMetric(this.getTitle());
        sendMetric('bloquear canal');
        const res = await RequestManager.addRequest(request)

        const {data : {channels_add , channels_delete} = {}} = res || {};
        const validateResponse = channels_add === 'OK' || channels_delete === 'OK';
        return validateResponse ? typeService : false;
    }

    async checkIsBlocked() {
        const request = new CheckBlockedChannels(this.getGroupId());
        try {
            const res = await RequestManager.addRequest(request);

            const {data : {channels_check = false} = {}} = res;
            if (channels_check) {
                if (Utils.modalType() === MODAL_OPTIONS_EVENT) {
                    this.setState({ isBlocked: true });
                }
                return true;
            } else {
                if (Utils.modalType() === MODAL_OPTIONS_EVENT) {
                    this.resetBlockedChannelState();
                }
                return false;
            }
        } catch (e) {
            logger.error('BlockedChannel checkIsBlocked catch err', e);
            if (Utils.modalType() === MODAL_OPTIONS_EVENT) {
                this.resetBlockedChannelState();
            }
            return false;
        }
    }

    updateBlockedChannels(toBlock) {
        const groupId = this.getGroupId();

        if (toBlock && this.isPlayingChannelByGroupId(groupId)) {
            this.moveNextChannel(groupId)
        }

        updateBlockedChannelsList(toBlock, groupId);
        UpdateMiniObserver.fire();
    }

    isPlayingChannelByGroupId(groupId) {

        const currentPlayerOptions = AAFPlayer.getCurrentPlayerOptions(false);
        const { source: { videoid } = {} } = currentPlayerOptions || {};

        return videoid === groupId;
    }


    async moveNextChannel(groupId) {

        let nextChannelAvailable = await TvChannelUtil.getNextChannelPlayable(groupId);
        if (nextChannelAvailable === groupId) nextChannelAvailable = false;

        if (nextChannelAvailable) {
            this.playNextChannel(nextChannelAvailable);
        } else {
            const { stopPlayer = () => { } } = this.props;
            stopPlayer();
        }
    }


    playNextChannel(groupId) {

        const newChannel = {
            playerstate: 'PLAYING',
            source: {
                videoid: groupId
            },
            size: {
                top: 0,
                left: 0,
                width: 1280,
                height: 720,
            },
            ispreview: false,
            islive: true,
            ispip: false,
            event: null,
        };

        store.dispatch(playFullMedia(newChannel));
    }

    componentDidMount() {
        this.checkIsBlocked();
    }

    render() {
        const { user: { session_userhash, user_token, isIptv } = {} } = this.props;
        const title = this.getTitle();
        //TODO remove || !isPinChannelActive to QR active pin page when necessary
        const userType = isIptv ? user_token : session_userhash;

        if (!userType) {
            return null;
        }

        return (
            <OptionButtonEvent
                title={title}
                onClick={this.handleClick}
                image={this.imageButton_block}
            />
        );
    }
}

BlockedChannel.propTypes = {
    showBlockedChannelNotification: PropTypes.func.isRequired,
    showUnBlockedChannelNotification: PropTypes.func.isRequired,
    handleClose: PropTypes.func.isRequired,
    data: PropTypes.object.isRequired,
    sendMetric: PropTypes.func.isRequired,
    stopPlayer: PropTypes.func.isRequireds,
};

BlockedChannel.defaultProps = {
    showBlockedChannelNotification: () => {},
    showUnBlockedChannelNotification: () => {},
    handleClose: () => {},
    data: {},
    sendMetric: () => {},
    stopPlayer: () => {},
};

export default withRouter(BlockedChannel);



// WEBPACK FOOTER //
// ./src/components/EventOptions/components/BlockedChannel.jsx